
import i18next from 'i18next';
import stringsEN from './translations/en'
import stringsHE from './translations/he'

i18next
  .init({
    interpolation: {
      // React already does escaping
      escapeValue: false,
    },
    lng: 'en', 
    // Using simple hardcoded resources for simple example
    resources: {
      en: {
        translation: stringsEN,
      },
      he: {
        translation: stringsHE,
      },
    },
  })

export default i18next



// WEBPACK FOOTER //
// ./src/i18n/i18n.js